module.exports = __webpack_public_path__ + "img/gb 2.9f129aa6.svg";